import { isPending } from "@reduxjs/toolkit";
import {
  UseQueryResult,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";

import { CustomerFormValues } from "./CustomerForm";
import { createCustomer, fetchCustomer, updateCustomer } from "./requests";

export const customerKeys = {
  current: () => ["customer"],
};
export const useCustomer = () =>
  useQuery({ queryKey: customerKeys.current(), queryFn: fetchCustomer });

export const useLoadedCustomer = () => {
  const { data, isError, error, isFetching, isPending } = useCustomer();
  if (isError) {
    throw `Error loading query, ${error.message}`;
  }
  if (isPending) {
    throw `Attempt to access loaded customer session that is  unloaded`;
  }
  if (!data) {
    throw `Attempt to access customer session that is  missing`;
  }

  return {
    data,
    isFetching,
  };
};

export const useSaveCustomer = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (
      customer: { id?: string } & Partial<CustomerFormValues>,
    ) => {
      if (customer.id) {
        return await updateCustomer({ ...customer });
      } else {
        return await createCustomer(customer);
      }
    },
    onSuccess: (customer) => {
      queryClient.setQueryData(customerKeys.current(), customer);
    },
  });
};
